import React from "react";
import './Home.css';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Link } from 'react-router-dom';
import Slider from "react-slick";
import MaterialIcon, { colorPalette } from 'material-icons-react';
import { Helmet } from "react-helmet";
import ContactForm from "../components/ContactForm";

const Home = () => {
    var settings = {
        dots: true,
        autoplay: true,
        autoplaySpeed: 2000,
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 5,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    // centerMode: true
                }
            }
        ]
    };

    return (
        <div>
            <Helmet>
                <title>Krisantec solutions</title>
                <meta name="description" content="No one size fits all. Your requirement is the favorite part of our portfolio. Work closely with us and see your idea grow from a prototype to solution stack customized to your needs." />
                <meta name="keywords" content="it company, it company in hyderabad, top it company in hyderabad, technology consultants" />
                <link rel="icon" href={require('../assets/images/favicon1.webp')} />
            </Helmet>
            <Navbar />
            <section class="herosection" id="home">
                <div class="container">
                    <div class="row">
                        <div class="col-md-6">
                            <h1>No <span className="color-primary">One Size</span> Fits All</h1>
                            <h5>Your requirement is the favourite part of our portfolio!</h5>
                            <h5>Work closely with us & see your idea grow from a prototype to a solution stack customized to your needs!!</h5>

                            <div className="hero-cta">
                                <button className="btn btn-primary" ><Link to="/contact-us" style={{color:'#ffffff', textDecoration:'none'}}>Contact us</Link></button>
                                <button className="btn btn-default" >Learn More</button>
                            </div>
                            <div className="hero-tech-info-container">
                                <p className="hero-tech-title">Stay Ahead with Trending Tech Stacks</p>
                                <div className="hero-tech-info">
                                    <div className="info-item">
                                        <img alt="React" src={require('../assets/images/technologies/react.webp')} width="100%" class="tech-icon" />
                                        <p>React</p>
                                    </div>
                                    <div className="info-item">
                                        <img alt="Python" src={require('../assets/images/technologies/python.webp')} width="100%" class="tech-icon" />
                                        <p>Python</p>
                                    </div>
                                    <div className="info-item">
                                        <img alt="Django" src={require('../assets/images/technologies/django.webp')} width="100%" class="tech-icon" style={{ borderRadius: '50%' }} />
                                        <p>Django</p>
                                    </div>
                                </div>
                                <div className="hero-tech-info">
                                    <div className="info-item">
                                        <img alt="AWS" src={require('../assets/images/technologies/aws.webp')} width="100%" class="tech-icon apply-mb-10" />
                                        <p>AWS</p>
                                    </div>
                                    <div className="info-item">
                                        <img alt="React Native" src={require('../assets/images/technologies/react-native.webp')} width="100%" class="tech-icon apply-mb-10" />
                                        <p>React Native</p>
                                    </div>
                                    <div className="info-item">
                                        <img alt="PostgreSQL" src={require('../assets/images/technologies/postgresql.webp')} width="100%" class="tech-icon apply-mb-10" />
                                        <p>PostgreSQL</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <img alt="krisantec img" src={require('../assets/images/hero.webp')} width="100%" class="hero-image" />
                        </div>
                    </div>
                </div>
            </section>
            <section class="why-us" id="about">
                <div class="container">
                    <div class="row">
                        <div class="col-md-6">
                            <img alt="krisantec img" src={require('../assets/images/hire.webp')} width="100%" class="hire-image" />
                        </div>
                        <div class="col-md-6">
                            <h2 class="lasting-values">Create Lasting Value</h2>
                            <p>Innovation is the heart of our applications. We incorporate the latest technologies to deliver breakthrough solutions. Building innovative applications requires a combination of creativity, technical expertise, and strategic vision. We beleive in cultivating innovation throughout the app development lifecycle, from ideation and prototyping to testing and deployment.</p>
                            <Link className="btn btn-primary jumplink" to="/contact-us">Contact Us</Link>
                        </div>
                    </div>
                </div>
            </section>
            <section class="projectd-completed">
                <div class="container">
                    <div class="row">
                        <div class="col-md-3">
                            <p class="count">20+</p>
                            <p class="p-title">Web Applications</p>
                        </div>
                        <div class="col-md-3">
                            <p class="count">10+</p>
                            <p class="p-title">App Projects</p>
                        </div>
                        <div class="col-md-3">
                            <p class="count">15+</p>
                            <p class="p-title">Health Care Projects</p>
                        </div>
                        <div class="col-md-3">
                            <p class="count">10</p>
                            <p class="p-title">FinTech Projects</p>
                        </div>
                    </div>
                </div>
            </section>
            <section class="features">
                <div class="container">
                    <h2>Core Competencies</h2>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="services-info">
                                <div class="row">
                                    <div class="col-1">
                                        <img alt="krisantec img" src={require('../assets/images/core/new-age-tech.png')} class="features-img" />
                                    </div>
                                    <div class="col-11">
                                        <p class="features-p">New Age Tech</p>
                                    </div>
                                    <div class="col-1">
                                        <img alt="krisantec img" src={require('../assets/images/core/holistic-approach.webp')} class="features-img" />
                                    </div>
                                    <div class="col-11">
                                        <p class="features-p">Holistic Approach</p>
                                    </div>
                                    <div class="col-1">
                                        <img alt="krisantec img" src={require('../assets/images/core/robust-execution-framework.webp')} class="features-img" />
                                    </div>
                                    <div class="col-11">
                                        <p class="features-p">Robust Execution Framework</p>
                                    </div>
                                    <div class="col-1">
                                        <img alt="krisantec img" src={require('../assets/images/core/contextual-knowledge.webp')} class="features-img" />
                                    </div>
                                    <div class="col-11">
                                        <p class="features-p">Contextual Knowledge</p>
                                    </div>
                                    <div class="col-1">
                                        <img alt="krisantec img" src={require('../assets/images/core/smarter-workforce.webp')} class="features-img" />
                                    </div>
                                    <div class="col-11">
                                        <p class="features-p">Smarter Workforce</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <img alt="krisantec img" src={require('../assets/images/features.webp')} width="100%" className="features-image" />
                        </div>
                    </div>
                </div>
            </section>
            <section class="banner-text">
                <div class="container">
                    <h2>Deploy The Best</h2>
                    <p>Our enterprise architects define streamlined self operating IT architecture to attain speed, and accuracy and prepare you to be future ready</p>
                </div>
            </section>
            <section class="services" id="services">
                <div class="container">
                    <h2>Industries We Serve</h2>
                    <div class="row">
                        <div class="col-md-3">
                            <div class="services-container">
                                <Link to="/services/business-domains/retail-software-system">
                                    <img alt="krisantec img" src={require('../assets/images/services/retail.webp')} width="100%" />
                                    <div class="services-info">
                                        <h3>Retail</h3>
                                    </div>
                                </Link>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="services-container">
                                <Link to="/services/business-domains/e-commerce">
                                    <img alt="krisantec img" src={require('../assets/images/services/ecommerce.webp')} width="100%" />
                                    <div class="services-info">
                                        <h3>E Commerce</h3>
                                    </div>
                                </Link>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="services-container">
                                <Link to="/services/business-domains/elearning">
                                    <img alt="krisantec img" src={require('../assets/images/services/education.webp')} width="100%" />
                                    <div class="services-info">
                                        <h3>Education</h3>
                                    </div>
                                </Link>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="services-container">
                                <Link to="/services/business-domains/healthcare-it">
                                    <img alt="krisantec img" src={require('../assets/images/services/healthcare.webp')} width="100%" />
                                    <div class="services-info">
                                        <h3>Healthcare</h3>
                                    </div>
                                </Link>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="services-container">
                                <Link to="/services/business-process/social-networking">
                                    <img alt="krisantec img" src={require('../assets/images/services/social.webp')} width="100%" />
                                    <div class="services-info">
                                        <h3>Social</h3>
                                    </div>
                                </Link>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="services-container">
                                <Link to="/services/business-process/erp-automation">
                                    <img alt="krisantec img" src={require('../assets/images/services/realestate.webp')} width="100%" />
                                    <div class="services-info">
                                        <h3>Real Estate</h3>
                                    </div>
                                </Link>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="services-container">
                                <Link to="/services/business-domains/information-technology">
                                    <img alt="krisantec img" src={require('../assets/images/services/it.webp')} width="100%" />
                                    <div class="services-info" style={{ marginTop: '40px' }}>
                                        <h3>Information Technology</h3>
                                    </div>
                                </Link>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="services-container">
                                <Link to="/services/it-development-consulting">
                                    <img alt="krisantec img" src={require('../assets/images/services/ondemand.webp')} width="100%" />
                                    <div class="services-info">
                                        <h3>On Demand Solutions</h3>
                                    </div>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="banner-text">
                <div class="container">
                    <h2>Fuelling Intelligent Decisions</h2>
                    <p>Drive agility using data analytics. We assist to add value to your business through monetization of data.</p>
                </div>
            </section>
            <section class="testimonials">
                <div class="container">
                    <h2>Discover Our Portfolio</h2>
                    <div class="items">
                        <Slider {...settings}>
                            <div>
                                <div class="clients-container">
                                    <img alt="krisantec img" src={require('../assets/images/clients/apollo.webp')} class='slider-images' />
                                    <h6>Apollo</h6>
                                </div>
                            </div>
                            <div>
                                <div class="clients-container">
                                    <img alt="krisantec img" src={require('../assets/images/clients/rainbow.webp')} class='slider-images' />
                                    <h6>Rainbow</h6>
                                </div>
                            </div>
                            <div>
                                <div class="clients-container">
                                    <img alt="krisantec img" src={require('../assets/images/clients/opoto.webp')} class='slider-images' />
                                    <h6>Opoto</h6>
                                </div>
                            </div>
                            <div>
                                <div class="clients-container">
                                    <img alt="krisantec img" src={require('../assets/images/clients/docbizz.webp')} class='slider-images' />
                                    <h6>Docbizz</h6>
                                </div>
                            </div>
                            <div>
                                <div class="clients-container">
                                    <img alt="krisantec img" src={require('../assets/images/clients/bookmyot.webp')} class='slider-images' />
                                    <h6>Book My OT</h6>
                                </div>
                            </div>
                            <div>
                                <div class="clients-container">
                                    <img alt="krisantec img" src={require('../assets/images/clients/vharvest.webp')} class='slider-images' />
                                    <h6>V-Harvest</h6>
                                </div>
                            </div>
                            <div>
                                <div class="clients-container">
                                    <img alt="krisantec img" src={require('../assets/images/clients/freshby.webp')} class='slider-images' />
                                    <h6>Freshby</h6>
                                </div>
                            </div>
                            <div>
                                <div class="clients-container">
                                    <img alt="krisantec img" src={require('../assets/images/clients/shopdiy.webp')} class='slider-images' />
                                    <h6>ShopDiy</h6>
                                </div>
                            </div>
                        </Slider>

                    </div>
                </div>
            </section>
            <section class="faqs">
                <div class="container">
                    <h2>FAQ'S</h2>
                    <p class="faqs-quote">Frequently asked questions from many people.</p>
                    <div class="accordion" id="accordionExample">
                        <div class="accordion-item">
                            <h3 class="accordion-header" id="headingOne">
                                <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                    How much do you charge for one project ?
                                </button>
                            </h3>
                            <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                <div class="accordion-body">
                                    That totally depends on the project, How much time will it take, What technology we are using, and the features required in the project.
                                </div>
                            </div>
                        </div>
                        <div class="accordion-item">
                            <h3 class="accordion-header" id="headingTwo">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                    When will you provide the code ?
                                </button>
                            </h3>
                            <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                                <div class="accordion-body">
                                    Acc. to our policy we will only provide the full code of the app after full payment. For testing purposes, we will provide an unsigned APK.
                                </div>
                            </div>
                        </div>
                        <div class="accordion-item">
                            <h3 class="accordion-header" id="headingThree">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                    How will you protect the code ?
                                </button>
                            </h3>
                            <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                                <div class="accordion-body">
                                    We will never share the code with any other client. Every repository of the code will be private and only the developer and client will have access to that.
                                </div>
                            </div>
                        </div>
                        <div class="accordion-item">
                            <h3 class="accordion-header" id="headingFour">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                    What payment methods you accept ?
                                </button>
                            </h3>
                            <div id="collapseFour" class="accordion-collapse collapse" aria-labelledby="headingFour" data-bs-parent="#accordionExample">
                                <div class="accordion-body">
                                    We accept almost all payment methods like UPI, Paytm, PhonePe, GPay, Bank transfer, Paypal, Stripe, etc.
                                </div>
                            </div>
                        </div>
                        <div class="accordion-item">
                            <h3 class="accordion-header" id="headingFive">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                                    What technologies do you specialize in ?
                                </button>
                            </h3>
                            <div id="collapseFive" class="accordion-collapse collapse" aria-labelledby="headingFive" data-bs-parent="#accordionExample">
                                <div class="accordion-body">
                                    As an IT development company, our specialization often depends on the specific expertise of our team members and the needs of our clients. However, here are some common technologies and platforms that we specialize in:
                                    <br /><b>Web Development:</b><br />Frontend: HTML5, CSS3, Bootstrap, JavaScript (React.js,React Native)<br />
                                    Backend:  Python, Django, Flask<br />
                                    <b> Mobile Development:</b><br />
                                    iOS: Swift, Objective-C<br />
                                    Android: React Native, Python<br />
                                    Cross-platform: React Native, Flutter<br />
                                    <b>Database Management:</b><br />
                                    SQL databases: MySQL, PostgreSQL, Microsoft SQL Server<br />
                                    <b>Cloud Computing:</b><br />
                                    Amazon Web Services (AWS)<br />
                                    <b>E-commerce Platforms:</b><br />
                                    ShopDiy<br />
                                    However our specialization can vary depending on project requirements and the evolving landscape of technology. We strive to stay updated with emerging technologies to provide innovative solutions to our clients.
                                </div>
                            </div>
                        </div>
                        <div class="accordion-item">
                            <h3 class="accordion-header" id="headingSix">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
                                    How do you ensure the security of the projects you work on ?
                                </button>
                            </h3>
                            <div id="collapseSix" class="accordion-collapse collapse" aria-labelledby="headingSix" data-bs-parent="#accordionExample">
                                <div class="accordion-body">
                                    Ensuring the security of the projects we work on is a top priority for our IT development company. Here are some key measures we take to uphold security standards:
                                    <br /><b>Risk Assessment:</b>
                                    <br />We conduct comprehensive risk assessments at the outset of each project to identify potential security vulnerabilities and threats.
                                    <br /><b>Secure Development Lifecycle:</b>
                                    <br />Our development process incorporates security measures at every stage, from design and coding to testing and deployment.
                                    <br /><b>Data Encryption:</b>
                                    <br />We implement encryption mechanisms, such as SSL/TLS for data transmission and encryption algorithms for data storage, to protect sensitive information.
                                    <br /><b>Access Control and Authentication:</b>
                                    <br />We enforce strict access control measures and implement robust authentication mechanisms to ensure that only authorized users can access the system.
                                    <br /><b>Client Collaboration:</b>
                                    <br />We maintain open communication with our clients regarding security concerns and involve them in decision-making processes related to security measures.
                                    <br /><br />By implementing these measures, we strive to build secure, reliable, and resilient systems that safeguard our clients' data and assets against potential threats and vulnerabilities.
                                </div>
                            </div>
                        </div>
                        <div class="accordion-item">
                            <h3 class="accordion-header" id="headingSeven">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSeven" aria-expanded="false" aria-controls="collapseSeven">
                                    What is your pricing structure ?
                                </button>
                            </h3>
                            <div id="collapseSeven" class="accordion-collapse collapse" aria-labelledby="headingSeven" data-bs-parent="#accordionExample">
                                <div class="accordion-body">
                                    Our pricing structure is tailored to the specific needs and requirements of each project. We understand that every project is unique, and factors such as complexity, scope, technology stack, timeline, and desired level of customization can all influence the cost.
                                    <br />However, we typically offer one or a combination of the following pricing models:
                                    <br /><b>Fixed Price:</b>
                                    <br />Under this model, we agree upon a fixed price for the entire project based on the project requirements and scope defined during the initial consultation. This pricing model works well for projects with clearly defined requirements and a stable scope.
                                    <br /><b>Time and Materials (T&M):</b>
                                    <br />With the time and materials model, the client pays based on the actual time spent by our team members and the materials (such as software licenses or third-party services) used during the project. This model offers flexibility, especially for projects with evolving requirements or where the scope is subject to change.
                                    <br /><b>Milestone-Based:</b>
                                    <br />For longer-term projects, we may structure the pricing based on project milestones. Payments are tied to the completion of predefined milestones or deliverables, providing transparency and accountability throughout the project lifecycle.
                                    <br /><b>Hybrid Models:</b>
                                    <br />Depending on the project's complexity and requirements, we may propose a hybrid pricing model that combines elements of fixed-price, time and materials, or milestone-based pricing to best suit the client's needs.
                                    <br /><br />During our initial consultation, we work closely with the client to understand their project goals, requirements, and budget constraints. Based on this information, we propose a pricing structure that aligns with their expectations and ensures a fair and transparent pricing arrangement.
                                    <br /><br />Additionally, we provide detailed estimates and breakdowns of costs, allowing clients to make informed decisions and prioritize features based on their budget and timeline. Our goal is to provide value-driven pricing that reflects the quality of our work and the outcomes achieved for our clients.
                                </div>
                            </div>
                        </div>
                        <div class="accordion-item">
                            <h3 class="accordion-header" id="headingEight">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseEight" aria-expanded="false" aria-controls="collapseEight">
                                    Do you offer any additional services, such as UX/UI design or digital marketing?
                                </button>
                            </h3>
                            <div id="collapseEight" class="accordion-collapse collapse" aria-labelledby="headingEight" data-bs-parent="#accordionExample">
                                <div class="accordion-body">
                                    Yes, we offer additional services beyond IT development, including UX/UI design and digital marketing. These services complement our core development offerings and provide a comprehensive solution to meet our clients' needs. Here's an overview of the additional services we offer:
                                    <br /><b>UX/UI Design:</b>
                                    <br />Our UX/UI design services focus on creating intuitive, user-friendly interfaces that enhance the overall user experience of digital products and applications. Our team of designers collaborates closely with clients to understand their target audience, brand identity, and project goals, and then crafts visually appealing and functional designs that meet these requirements. We offer services such as wireframing, prototyping, user testing, and interface design to ensure that the final product aligns with our clients' vision and exceeds user expectations.
                                    <br /><b>Digital Marketing:</b>
                                    <br />In addition to development and design, we provide digital marketing services to help clients promote their products and reach their target audience effectively. Our digital marketing team offers a range of services, including search engine optimization (SEO), pay-per-click (PPC) advertising, social media marketing, content marketing, email marketing, and analytics. We tailor our digital marketing strategies to each client's unique needs and objectives, helping them increase visibility, drive traffic, generate leads, and ultimately achieve their business goals.
                                    <br /><br />By offering these additional services, we provide clients with a comprehensive solution for their digital projects, covering everything from initial concept and design to development, promotion, and ongoing optimization. This integrated approach ensures seamless collaboration, consistent branding, and maximum impact for our clients' digital initiatives.
                                </div>
                            </div>
                        </div>
                        <div class="accordion-item">
                            <h3 class="accordion-header" id="headingNine">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseNine" aria-expanded="false" aria-controls="collapseNine">
                                    Do you provide ongoing support and maintenance after the project is completed?
                                </button>
                            </h3>
                            <div id="collapseNine" class="accordion-collapse collapse" aria-labelledby="headingNine" data-bs-parent="#accordionExample">
                                <div class="accordion-body">
                                    Yes, we provide ongoing support and maintenance services to ensure the continued smooth operation and optimal performance of the projects we deliver. Our support and maintenance services are designed to address any issues, updates, or enhancements that may arise after the project is completed. Here's an overview of what our ongoing support and maintenance services typically include:
                                    <br /><b>Bug Fixes and Issue Resolution:</b>
                                    <br />We promptly address any bugs, errors, or issues that may arise in the software after deployment. Our team investigates reported issues, identifies the root cause, and implements appropriate fixes to restore functionality and stability.
                                    <br /><b>Software Updates and Upgrades:</b>
                                    <br />We ensure that the software is kept up to date with the latest versions of libraries, frameworks, and dependencies to maintain compatibility, security, and performance.
                                    <br /><b>Performance Monitoring and Optimization:</b>
                                    <br />This includes monitoring resource utilization, response times, and user feedback to optimize performance and scalability.
                                    <br /><b>Security Maintenance:</b>
                                    <br />This includes applying security patches, conducting security audits, and implementing additional security controls to mitigate risks and ensure data integrity and confidentiality.
                                    <br /><b>Data Backup and Disaster Recovery:</b>
                                    <br />We regularly back up critical data and establish recovery procedures to minimize downtime and data loss.
                                    <br /><b>User Support and Training:</b>
                                    <br />We provide ongoing user support and training to help users effectively utilize the software and address any questions or issues they may encounter. This includes providing documentation, FAQs, tutorials, and user training sessions to empower users and enhance their experience.
                                    <br /><b>Feature Enhancements and Additions:</b>
                                    <br />We collaborate with clients to identify opportunities for feature enhancements or additions based on evolving business needs, user feedback, or industry trends.
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </section>
            <section class="contact" id="contact">
                <div class="container">
                    <h2>Our Work Speaks For Us</h2>
                    <p class="contact-quote">Do You Have A Project That You Would Like To Discuss On? Talk To Our Expert</p>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="email">
                                        <MaterialIcon icon="mail" size={40} color={"#0d53ad"} />
                                        <h3>Email</h3>
                                        <p><a href="mailto:info@krisantec.com" className="anchor-text">info@krisantec.com</a></p>
                                        <br />
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="phone">
                                        <MaterialIcon icon="phone_in_talk" size={40} color={"#0d53ad"} />
                                        <h3>Call</h3>
                                        <p><a href={`tel:+91 8712874770`} className="anchor-text">+91 8712874770</a></p>
                                        <br />
                                    </div>
                                </div>
                            </div>
                            <div class="address mb-5">
                                <MaterialIcon icon="pin_drop" size={40} color={"#0d53ad"} />
                                <h3>Address</h3>
                                <p>Suraj Mansion, #202, Shyam Karan Rd, Leelanagar, Hyderabad, Telangana 500016</p><br />
                                <button type="submit" class="btn btn-primary"><a href="https://www.google.com/maps/dir/?api=1&destination=17.436851691041547,78.4529135003686&travelmode=driving" target="_blank" style={{ color: '#ffffff', textDecoration: 'none' }}>Get Directions</a></button>
                                <br />
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="box-with-shadow">
                                <h2>Submit Your Query</h2>
                                {/* <form action="">
                                    <div class="mb-3 mt-3">
                                        <label for="name">Name:</label>
                                        <input type="name" class="form-control" id="name" placeholder="Enter Name" name="name" />
                                    </div>
                                    <div class="mb-3 mt-3">
                                        <label for="contact">Contact No:</label>
                                        <input type="contact" class="form-control" id="contact" placeholder="Enter Contact No "
                                            name="contact" />
                                    </div>
                                    <div class="mb-3 mt-3">
                                        <label for="email">Email:</label>
                                        <input type="email" class="form-control" id="email" placeholder="Enter Email" name="email" />
                                    </div>
                                    <div class="mb-3 mt-3">
                                        <label for="query">Query:</label>
                                        <textarea class="form-control" rows="2" id="query" name="query"></textarea>
                                    </div>
                                    <button type="submit" class="btn btn-primary">Submit</button>
                                </form> */}
                                <ContactForm />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    );
};

export default Home;